import { useODataReadListApi, useODataReadSingleApi, useOdataPostSingleApi, useODataReadInfiniteApi, } from './odata';
import { merge } from '@fluentui/react';
export const endpointVuln = '/portal/v2.0/vulnerabilityReport';
/** Odata API for accessing a list of vulnerability reports the current user has access to. */
export const useVulnReportListApi = (query, pageLength = 15, options) => useODataReadListApi(endpointVuln, query, merge({}, {
    pageLength,
    uniqueIdentifier: 'id',
    isAuthRequired: true,
    isVerificationRequired: true,
}, options));
/** Odata API for accessing an infinite list of vulnerability reports the current user has access to. */
export const useVulnReportInfiniteApi = (query, pageLength = 30, options) => useODataReadInfiniteApi(endpointVuln, query, merge({}, {
    isAuthRequired: true,
    isVerificationRequired: true,
    pageLength,
}, options));
/** Odata API for accessing single vulnerability reports the current user has access to. */
export const useVulnReportSingleApi = (id, options) => useODataReadSingleApi(endpointVuln, 
//TODO: Don't hardcode, instead pass a query that supports expands
id && `${id}?$expand=changeLog`, merge({}, {
    enabled: true,
    isAuthRequired: true,
    isVerificationRequired: true,
}, options));
/** OData mutation API for sending new vuln reports */
export const useVulnReportMutationApi = () => useOdataPostSingleApi(endpointVuln, undefined, undefined, { delayAdditionalEndpoints: 250 });
//TODO: Add this in when vuln report gets flag/unflag all support
/** React-query mutation API for modifying individual existing reports */
// export const useVulnReportPatchApi = () =>
//   useOdataPostSingleApi<Pick<VulnerabilityReport, 'flagged'>>(endpoint);
